import { render, staticRenderFns } from "./GearsIcon.vue?vue&type=template&id=3b446481&"
import script from "./GearsIcon.vue?vue&type=script&lang=js&"
export * from "./GearsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports